module.exports = __webpack_public_path__ + "saba-island.svg?92315156430649c9bb0d0236f614127a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/saba-island.svg
// module id = 278
// module chunks = 10